import React, { useEffect } from 'react';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { asyncCompassTableCrossFlowTouchPoint } from './entrypoint.tsx';
import type { Props } from './types.tsx';

const entryPointParams = {};
// External facing component, exported out of package.
export const AsyncCompassTableCrossFlowTouchPoint = (props: Props) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		asyncCompassTableCrossFlowTouchPoint,
		entryPointParams,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id="jira.compass.table-cross-flow"
			packageName="jiraCompassCrossFlow"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={props}
		/>
	);
};

export default AsyncCompassTableCrossFlowTouchPoint;
